import React, { useRef } from "react";
import MultiLineChart from "./line";
import MultiBarChart from "./bar";
import MultiAreaChart from "./area";
import PieChart from "./pie";
import { arrSum } from "./lib/utilty";

export default function Chart({
  type = "line",
  dataSets = [{ name: "", data: [] }],
  labels = [],
  width = 250,
  height = 200,
  title = "",
  xLabel = "",
  yLabel = "",
}) {
  const chartRef = useRef(null);
  // No longer need to separate name and data here, pass dataSets directly

  const handleDownload = () => {
    const svgElement = chartRef.current.querySelector("svg");
    const svgData = new XMLSerializer().serializeToString(svgElement);
    const canvas = document.createElement("canvas");
    const svgSize = svgElement.getBoundingClientRect();
    canvas.width = svgSize.width;
    canvas.height = svgSize.height;
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.onload = () => {
      ctx.drawImage(img, 0, 0);
      const canvasUrl = canvas.toDataURL("image/png");
      const downloadLink = document.createElement("a");
      downloadLink.href = canvasUrl;
      downloadLink.download = "chart.png";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    };
    img.src = "data:image/svg+xml;base64," + btoa(svgData);
  };

  switch (type) {
    case "line":
      return (
        <div
          style={{
            border: "1px solid #ccc",
            padding: "10px",
            borderRadius: "5px",
          }}
          ref={chartRef}
        >
          <MultiLineChart
            dataSets={dataSets} // Pass the full dataSets prop
            labels={labels}
            width={width}
            height={height}
            title={title}
            xLabel={xLabel}
            yLabel={yLabel}
          />
          <button onClick={handleDownload}>Download Chart</button>
        </div>
      );
    case "bar":
      return (
        <div
          style={{
            border: "1px solid #ccc",
            padding: "10px",
            borderRadius: "5px",
          }}
          ref={chartRef}
        >
          <MultiBarChart
            dataSets={dataSets} // Pass the full dataSets prop
            labels={labels}
            width={width}
            height={height}
            title={title}
            xLabel={xLabel}
            yLabel={yLabel}
          />
          <button onClick={handleDownload}>Download Chart</button>
        </div>
      );
    case "area":
      return (
        <div
          style={{
            border: "1px solid #ccc",
            padding: "10px",
            borderRadius: "5px",
          }}
          ref={chartRef}
        >
          <MultiAreaChart
            dataSets={dataSets} // Pass the full dataSets prop
            labels={labels}
            width={width}
            height={height}
            title={title}
            xLabel={xLabel}
            yLabel={yLabel}
          />
          <button onClick={handleDownload}>Download Chart</button>
        </div>
      );
    case "pie":
      // calculate the total value of each data set
      // calculate the total value of each data set and include color
      const pieData = dataSets.map((item) => {
        const total = arrSum(item.data);
        return {
          label: item.name,
          value: total,
          color: item.color, // Include color for PieChart
        };
      });
      return (
        <div
          style={{
            border: "1px solid #ccc",
            padding: "10px",
            borderRadius: "5px",
          }}
          ref={chartRef}
        >
          <PieChart data={pieData} size={width} title={title} />
          <button onClick={handleDownload}>Download Chart</button>
        </div>
      );
    default:
      return null;
  }
}
